import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { FirmwareScene } from 'scenes';

class FirmwareContainer extends AbstractContainer {
  getTasks(params) {

    let version = params.version;
    let channel = params.channel;

    return [
      {
        key: 'firmware',
        exec: (done, failure) => {
          API.get(`/firmwares/${channel}/${version}`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
    ]
  }

  getComponent(results) {
    return <FirmwareScene firmware={results.firmware} />
  }
}

export default FirmwareContainer;
